import { Visibility } from "@mui/icons-material";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  Box,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { MaterialReactTable } from "material-react-table";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { auditarExportacion, CODIGO_AUDITORIA } from "../../../../actions/audit";
import { getFormatoFechaExportacion } from "../../../../utils/datetimeUtils";
import { downloadCsv } from "../../../../utils/filesUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";

const SearchConnectivityErrorsTable = ({
  data,
  namesArts,
  loading,
  title,
  noRefresh,
  fetchData,
  time,
  handleChangeTime,
  displayAccidents,
  handleOpenAccidentDetail,
}) => {
  const dispatch = useDispatch();
  const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
  const columns = [
    {
      header: "Fecha Formulario",
      accessorKey: "fechaFormulario",
      Filter: ({ column }) => {
        const [selectedDate, setSelectedDate] = React.useState(null);

        return (
          <DatePicker
            value={selectedDate}
            onChange={(newValue) => {
              setSelectedDate(newValue);
              column.setFilterValue(
                newValue ? moment(newValue).format("YYYY-MM-DD") : undefined,
              );
            }}
            slotProps={{
              textField: {
                variant: "standard",
                sx: {
                  "& .MuiInputBase-root": {
                    height: 35,
                  },
                  "& .MuiOutlinedInput-input ": {
                    height: 5,
                  },
                  "& .MuiChip-root": {
                    height: 1,
                  },
                },
              },
            }}
            renderInput={(params) => <TextField fullWidth {...params} />}
          />
        );
      },
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue) return true; // Mostrar todas las filas si no hay filtro activo
        const cellValue = row.getValue(columnId); // Obtener el valor de la celda
        if (!cellValue) return false; // Excluir filas sin fecha si hay filtro
        return moment(cellValue).isSame(filterValue, "day"); // Verificar coincidencia exacta
      },
      Cell: ({ row }) =>
        moment(row.original.fechaFormulario).isValid()
          ? moment(row.original.fechaFormulario).format("DD/MM/YYYY")
          : "",
    },
    {
      header: "Siniestro",
      accessorKey: "historiaClinica",
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Documento",
      accessorKey: "documento",
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Trabajador",
      accessorFn: (row) => row.trabajador || "",

      enableColumnActions: false,
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          fontSize: 12,
          wordWrap: "break-word",
        },
      },
      filterFn: (row, columnId, filterValue) => {
        const fullName = (row.original.trabajador || "").toLowerCase();
        return fullName.includes(filterValue.toLowerCase());
      },

      Cell: ({ row }) => row.original.trabajador || "",
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Empleador",
      accessorKey: "empleador",
      muiTableBodyCellProps: {
        sx: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          fontSize: 12,
        },
      },
      enableColumnActions: false,
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Formulario",
      accessorKey: "formulario",

      Cell: (rowData) => (
        <Box
          sx={{
            textAlign: "center",
          }}>
          {rowData.row.original.formulario}
        </Box>
      ),
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Error",
      accessorKey: "error",

      Cell: (rowData) => (
        <Box
          sx={{
            textAlign: "center",
          }}>
          {rowData.row.original.error}
        </Box>
      ),
      Filter: ({ column }) => (
        <TextField
          variant="standard"
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: 35,
              minHeight: "unset",
            },
            "& .MuiOutlinedInput-input": {
              height: 5,
            },
          }}
          value={column.getFilterValue() || ""}
          onChange={(e) => column.setFilterValue(e.target.value)}
        />
      ),
    },
    {
      header: "Detalle",
      accessorKey: "detalle",
      enableSorting: false,
      enableColumnActions: false,

      enableColumnFilter: false,

      accessorFn: (row) => row.detalle || "", // Asegurar que el texto completo se use en el filtrado y ordenamiento
      Cell: ({ row }) => {
        const { detalle } = row.original;

        return detalle?.length > 20 ? (
          <Tooltip title={detalle} TransitionComponent={Zoom} arrow>
            <Typography
              variant="caption"
              sx={{
                whiteSpace: "normal", // Ajustar contenido en las celdas
                wordWrap: "break-word",
                fontSize: "0.85rem",
              }}>
              {detalle.substring(0, 20)} <b>[...ver más]</b>
            </Typography>
          </Tooltip>
        ) : (
          <Typography variant="caption">{detalle || ""}</Typography>
        );
      },
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      enableSorting: false,
      enableColumnFilter: false,
      enableColumnActions: false,

      Cell: ({ row }) => (
        <Tooltip title="Ver Detalles">
          <IconButton
            onClick={() => handleOpenAccidentDetail(row.original)}
            size="small"
            color="inherit">
            <Visibility />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const handleExportToCsv = () => {
    setIsDownloadingCsv(true);
    dispatch(auditarExportacion(data, "mlCloudCoreArtId", CODIGO_AUDITORIA.EXPORTACION_CONECTIVIDAD))
      .then(() => {
        const encabezado = [
          "Fecha Formulario",
          "Siniestro",
          "Documento",
          "Trabajador",
          "Empleador",
          "Formulario",
          "Error",
          "Detalle",
        ];

        const formattedDataAsCsv = [encabezado, ...formatTableDataForExport(data)];

        let csvContent = "sep=,\n";
        csvContent += formattedDataAsCsv.map((row) => row.join(",")).join("\n");

        downloadCsv(csvContent, title);
        snackbarUtils.success("Los errores han sido descargados con éxito.");
        setIsDownloadingCsv(false);
      })
      .catch((error) => {
        snackbarUtils.error(error);
        setIsDownloadingCsv(false);
      });
  };

  const formatTableDataForExport = (table) => {
    return table.map((fila) => [
      fila.art ? `"${fila.art}"` : "",
      getFormatoFechaExportacion(fila.fechaFormulario, "dd/MM/yyyy"),
      fila.siniestro ? `"${fila.siniestro}"` : "",
      fila.documento ? `"${fila.documento}"` : "",
      `${fila.nombreTrabajador || ""} ${fila.apellidoTrabajador || ""}`.trim(),
      fila.empleador ? `"${fila.empleador}"` : "",
      fila.formulario ? `"${fila.formulario}"` : "",
      fila.error ? `"${fila.error}"` : "",
      fila.detalle ? `"${fila.detalle}"`.trim() : "",
    ]);
  };

  return (
    <>
      {displayAccidents !== "block" ? (
        <></>
      ) : (
        <MaterialReactTable
          {...tableConfig}
          columns={columns}
          data={data}
          state={{
            isLoading: loading || isDownloadingCsv,
          }}
          renderTopToolbarCustomActions={() => (
            <Box m={0.5}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center">
                <TitleContainer
                  title={title}
                  noRefresh={noRefresh}
                  fetchData={fetchData}
                />
                <Box>
                  <Tooltip title="Exportar CSV" arrow="top">
                    <IconButton sx={{ margin: 2 }} onClick={handleExportToCsv}>
                      <GetAppIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Box>
          )}
        />
      )}
    </>
  );
};

export default SearchConnectivityErrorsTable;
